import classNames from 'classnames';
import { AccordionButton, AccordionButtonProps } from 'react-bootstrap';

import './style.scss';

type AccordionHeaderProps = AccordionButtonProps & {
  withoutArrow?: boolean;
};

export function SpAccordionHeader({ className, withoutArrow = false, ...props }: AccordionHeaderProps) {
  return (
    <AccordionButton
      as="div"
      {...props}
      className={classNames(
        'w-100 p-0 shadow-none',
        { 'accordion-without-arrow  pe-0': withoutArrow },
        { 'pe-4': !withoutArrow },
        className,
      )}
    />
  );
}
